module.exports = __webpack_public_path__ + "static/img/banner-mobile2.3991ecf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-mobile2.jpg
// module id = FcFE
// module chunks = 1